import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarComponent } from './components/calendar/calendar.component';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

const routes: Routes = [

    // { path: '', redirectTo: 'dispatch', pathMatch: 'full'},
    {
      path: 'embed_calendar',
      canActivate: [AuthGuard],
      canActivateChild: [AuthGuard],
      component: LayoutComponent,
      pathMatch: 'full',
      resolve: {
          initialData: InitialDataResolver,
      },
      data: {
        layout: 'empty',
        app: 'calendar'
      },
      children: [
          { path: '',
          component: CalendarComponent}
      ]
    },
    // Admin routes
    {
        path: 'calendar',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
            path: '', component: CalendarComponent,
            data: { module: 'CALENDAR', type: 'NON_JOB_EVENT' }
          }
        ]
    },
    { path: 'calendar', redirectTo: 'calendar' },
    { path: '', redirectTo: 'calendar', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
